import api from './api';

export interface Visitor {
  _id: string;
  agencyId: string;
  attendeeId?: any;
  propertyId?: string;
  agentId: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  budgetMin?: number;
  budgetMax?: number;
  inspectionDate: string;
  inspectionTime: string;
  propertyAddress?: {
    street: string;
    city: string;
    state: string;
    country: string;
    postalCode: string;
    formattedAddress?: string;
    latitude?: number;
    longitude?: number;
  };
  contractSent: boolean;
  contractSentAt?: string;
  contractDocumentUrl?: string;
  notes: string;
  tags: string[];
  status: 'scheduled' | 'completed' | 'cancelled' | 'no_show';
  followUpDate?: string;
  followUpNotes?: string;
  interestLevel: 'high' | 'medium' | 'low';
  source: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateVisitorData {
  propertyId?: string;
  sessionId?: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  inspectionDate: string;
  inspectionTime: string;
  budgetMin?: number;
  budgetMax?: number;
  propertyAddress?: any;
  notes?: string;
  feedback?: string;
  priceFeedback?: string;
  followUpIntent?: 'wants_contract' | 'wants_second_inspection' | 'considering' | 'not_interested' | 'no_follow_up';
  objections?: string;
  tags?: string[];
  interestLevel?: 'high' | 'medium' | 'low' | 'none';
  source?: string;
  contractSent?: boolean;
  requestsApplicationForm?: boolean;
  visitType?: 'viewing' | 'inspection' | 'open_house' | 'private_viewing' | 'other';
}

const visitorService = {
  createVisitor: async (agencySlug: string, visitorData: CreateVisitorData): Promise<Visitor> => {
    const response = await api.post(`/agencies/${agencySlug}/visitors`, visitorData);
    return response.data;
  },

  updateVisitor: async (agencySlug: string, visitorId: string, updateData: Partial<CreateVisitorData>): Promise<Visitor> => {
    const response = await api.put(`/agencies/${agencySlug}/visitors/${visitorId}`, updateData);
    return response.data;
  },

  deleteVisitor: async (agencySlug: string, visitorId: string): Promise<void> => {
    await api.delete(`/agencies/${agencySlug}/visitors/${visitorId}`);
  }
};

export default visitorService;
